module.exports = __webpack_public_path__ + "static/media/sortingup-gray.fa143518.svg";